/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { IActiveTabState } from './data-actions/tab-state';
import { createTabStateInput } from './data-actions/tab-state-data-action';
import tab from './modules/tab/tab';
import tabView from './modules/tab/tab.view';
import { getContentID, TabItemType } from './modules/tab-item/tab-item';

export * from './modules/tab/tab';
export * from './modules/tab/tab.view';
export {
    createTabStateInput,
    getContentID,
    IActiveTabState,
    tab,
    TabItemType,
    tabView };
